(() => {
  const gallery = document.querySelector('.fun-ren-commissions');
  if (!gallery) return;
  const select = gallery.querySelector('#commission-reference');
  gallery.addEventListener('click', (event) => {
    const link = event.target.closest('[data-commission-reference]');
    if (!link || !select) return;
    gallery.querySelector('#commission-enquiry').open = true;
    select.value = `New commission — reference ${link.dataset.commissionReference}`;
    select.focus({ preventScroll: true });
  });
})();
